import { ReactCompareSlider } from "react-compare-slider"
import cns from "classnames"
import { pick } from "lodash"
import { motion } from "framer-motion"

import { Image, Carousel, Section, Title } from "components/shared"
import { useAnimation } from "utils/useAnimation"

const DETAIL_ATTRIBUTES = {
  treatment: "Treatment",
  grafts: "Number Of Grafts",
  duration: "Duration After Treatment",
  cost: "Cost",
}

const DetailText = ({ attribute, value }) => {
  const { variants } = useAnimation()
  // const variants = itemVariants()
  return (
    <motion.div className="flex space-x-2 sm:space-x-10 text-lg" variants={variants}>
      <div className="capitalize font-medium sm:font-semibold sm:min-w-[240px]">{attribute}:</div>
      <div className="font-semibold">{value}</div>
    </motion.div>
  )
}

const BeforeAndAfter = ({ id, results, isReversed }) => {
  const { animation, variants } = useAnimation()
  const { animation: containerAnimation } = useAnimation("container")
  const { animation: decorationAnimation } = useAnimation("decoration")

  const animationProps = animation
  const decorationProps = decorationAnimation
  const container = containerAnimation

  return (
    <Section
      id={id}
      contentClassName="space-y-8 md:space-y-12 xl:space-y-36"
      decoration={
        <motion.div className="hidden lg:flex absolute bg-blue-200/80 h-[520px] bottom-[110px] left-0 w-[35%]" {...decorationProps} />
      }
      padding="lg"
      animate
    >
      <Title title="Hair restoration that changes lives" pretitle="Patient Stories" animate />
      <Carousel isReversed={isReversed} fade arrowsInside swipe={false}>
        {results?.map((result, index) => {
          const meta = pick(result, ["duration", "cost", "grafts", "treatment"])
          return (
            <div
              className={cns(
                "!flex flex-col-reverse lg:flex-row space-y-8 space-y-reverse lg:space-y-0 lg:space-x-10",
                isReversed && "lg:flex-row-reverse"
              )}
              key={index}
            >
              <motion.div
                className="flex-1 flex mx-auto justify-center relative w-[20rem] h-[16rem] md:w-[30rem] md:h-[24rem] lg:w-[34rem] lg:h-[26rem] overflow-hidden"
                {...animationProps}
              >
                {/* <div className="absolute left-0 bg-blue-200 h-[200%] w-[400px]"></div> */}
                <ReactCompareSlider
                  itemOne={
                    <Image
                      image={result?.before}
                      className={cns("w-[20rem] h-[16rem] md:w-[30rem] md:h-[24rem] lg:w-[34rem] lg:h-[26rem]")}
                      animate
                    />
                  }
                  itemTwo={
                    <Image
                      image={result?.after}
                      className={cns("w-[20rem] h-[16rem] md:w-[30rem] md:h-[24rem] lg:w-[34rem] lg:h-[26rem]")}
                      animate
                    />
                  }
                />
              </motion.div>
              <div className="lg:!mt-3 flex-1 flex flex-col lg:space-y-2">
                <motion.div className="space-y-8 relative" {...container}>
                  <motion.p className="text-lg text-blue-600 leading-relaxed max-w-xl" variants={variants}>
                    Behind each before and after is a person who wanted their reflection to match how they feel. The figures below tell you
                    how long after treatment this result was captured, what was involved, and the investment, so you can see the full
                    picture, not just the photo.
                  </motion.p>
                  <div className="space-y-4 sm:space-y-2">
                    {Object.keys(meta).map(
                      (attribute, index) =>
                        meta[attribute] && <DetailText key={index} attribute={DETAIL_ATTRIBUTES[attribute]} value={meta[attribute]} />
                    )}
                  </div>
                  <motion.div className="hidden md:block" variants={variants}>
                    <p className="p line-clamp-4 text-xl" title={result?.description}>
                      {result?.description}
                    </p>
                  </motion.div>
                </motion.div>
              </div>
            </div>
          )
        })}
      </Carousel>
    </Section>
  )
}

export default BeforeAndAfter
